var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
export class Profile {
  constructor(_data) {
    /**
     */
    __publicField(this, "Email");
    /**
     */
    __publicField(this, "TwoFactorEnabled");
    /**
     * Adds support for polymorphism. The discriminator is the schema property
     * name that is used to differentiate between other schema that inherit this
     * schema.
     *
     * @protected
     * @type {string}
     * @memberof Profile
     */
    __publicField(this, "$type", "V1.Profiles.Profile");
    if (_data) {
      for (const property in _data) {
        if (_data.hasOwnProperty(property)) {
          this[property] = _data[property];
        }
      }
    }
  }
  /**
   * Initializes a new model instance.
   */
  init(_data) {
    if (_data) {
      this.Email = _data["Email"];
      this.TwoFactorEnabled = _data["TwoFactorEnabled"];
    }
    return this;
  }
  toJSON(_data) {
    _data = typeof _data === "object" ? _data : {};
    _data["Email"] = this.Email;
    _data["TwoFactorEnabled"] = this.TwoFactorEnabled;
    return _data;
  }
}
